import React from "react";
import "./about.css";
// import SectionName from '../section-name/section-name';
function About() {
  return (
    <div id="about">
      <div className="about-section" data-aos="fade-up">
        {/* <SectionName name="About Buyers Galaxy"/> */}
        <h1>
          <span className="underlines">About Buyers</span>Galaxy
        </h1>
        <p>
          At Buyers Galaxy, we specialize in helping buyers confidently navigate
          Melbourne’s competitive property market. As Victoria’s trusted buyer’s
          agency, we bring insider knowledge from years of experience as real
          estate sales associates and auction specialists. This expertise allows
          us to understand vendor strategies, recognize fair property prices, and
          negotiate with an edge that benefits you.
        </p>
        <div className="makes-differ">
          <span>What Makes Us Different?</span>
          <ul>
              <li className="l1"><b>Investor-First Approach</b></li>
              <li className="l2"><b>Insider Knowledge</b></li>
              <li className="l3"><b>Industry Connections</b></li>       
              <li className="l4"><b>Stress-Free Journey</b></li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default About; 
